<div class="loading">
    <div class="wrapper">
        <div class="loading-container">
            <span class="taiji-icon"></span>
            <p>Loading...</p>
        </div>
    </div>
</div>
